export function isSyncBoxConfigForNodeId(context) {
    return Boolean(context && 'nodeId' in context);
}
export function isSyncBoxConfigForSyncBox(context) {
    return Boolean(context && 'syncBoxFilters' in context);
}
